export default __webpack_public_path__ + "static/Mysql_logo-a04abbf76b39676bc4d9689ac70681c4.png";